import { Userpilot } from 'userpilot'
import { USER_INFO_KEY } from "../constants/common";
import { get } from "lodash";


export const initUserPilot = (token) => {
  Userpilot.initialize(token);
};

export const identifyUser = (userId, userData) => {
  Userpilot.identify(userId, userData);
};

export const identifyUserByLocalStorage = (userDetailsFromStore) => {
  return new Promise((resolve) => {
    const user = JSON.parse(localStorage.getItem(USER_INFO_KEY) || '{}');
    const userInfo = get(user, 'userInfo');

    if(!userInfo) {
      resolve();
      return;
    }

    identifyUser(
      userInfo.userId,
      {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        name: [userInfo.firstName, userInfo.lastName].filter(Boolean).join(' '),
        email: user.email || '',
        userType: user.userType || '',
        planName: get(userDetailsFromStore, '0.PlanName'),
        planPeriod: get(userDetailsFromStore, '0.period')
      }
    );
    resolve();
  });
}


export const trackEvent = (eventName, properties) => {
  Userpilot.track(eventName, properties);
};

export const trigger = (token) => {
  Userpilot.trigger(token)
}

export const triggerOnboarding = async () => {
  await identifyUserByLocalStorage();
  trigger(process.env.REACT_APP_USERPILOT_ONBOARDING_FLOW_KEY);
}


export const showUserPilotOnboarding = () => {
  localStorage.setItem("showUserPilotOnboarding","true")
}

export const reloadUserPilot = () => {
  Userpilot.reload()
}

export default Userpilot;
